class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    
    // Ne plus écouter l'input automatiquement - on attend le clic sur le bouton confirmer
    // this.debouncedOnSubmit = debounce((event) => {
    //   this.onSubmitHandler(event);
    // }, 500);
    // this.querySelector("form").addEventListener("input", this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
    
    this.updateResetButtonsVisibility();
    updateSortBy();
    
    // Initialiser le bouton confirmer desktop
    this.initConfirmButton();
  }

  initConfirmButton() {
    const confirmButton = document.getElementById('FacetsConfirmButton');
    if (confirmButton) {
      confirmButton.addEventListener('click', () => {
        this.applyFilters();
        // Fermer le drawer après confirmation
        document.querySelector("#main-collection-filters").classList.remove("filters-actif");
      });
    }

    const mobileConfirmButton = document.getElementById('MobileFacetsConfirmButton');
    if (mobileConfirmButton) {
      mobileConfirmButton.addEventListener('click', () => {
        this.applyFilters('mobile');
        // Fermer le drawer mobile après confirmation
        const mobileWrapper = document.querySelector('.mobile-facets__wrapper');
        if (mobileWrapper) {
          const summary = mobileWrapper.querySelector('summary');
          if (summary) summary.click();
        }
      });
    }
  }

  applyFilters(type = 'desktop') {
    const formId = type === 'mobile' ? 'FacetFiltersFormMobile' : 'FacetFiltersForm';
    const form = document.getElementById(formId);
    if (form) {
      const formData = new FormData(form);
      const searchParams = new URLSearchParams(formData).toString();
      FacetFiltersForm.renderPage(searchParams, null);
    }
  }

  updateResetButtonsVisibility() {
    document.querySelectorAll(".facets__disclosure").forEach((item) => {
      let count = item.querySelectorAll(".facets__display input:checked").length;
      const resetBtn = item.querySelector(".facets__reset");
      if (resetBtn) {
        resetBtn.style.display = count === 0 ? "none" : "block";
      }
    });
  }

  static updateBtn() {
    document.querySelectorAll(".facets__disclosure").forEach((item) => {
      let count = item.querySelectorAll(".facets__display input:checked").length;
      if (count == 0) {
        const resetBtn = item.querySelector(".facets__reset");
        if (resetBtn) resetBtn.remove();
      }
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById("ProductCountDesktop");
    
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams.replaceAll("*", "")}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;
    reloadPagination();
    updateSortBy();
    
    document.querySelectorAll(".facets__disclosure").forEach((item) => {
      let count = item.querySelectorAll(".facets__display input:checked").length;
      const resetBtn = item.querySelector(".facets__reset");
      if (resetBtn) {
        resetBtn.style.display = count === 0 ? "none" : "block";
      }
    });
  }

  static renderProductCount(html) {
    // const count = new DOMParser()
    //   .parseFromString(html, "text/html")
    //   .getElementById("ProductCount").innerHTML;
    // const container = document.getElementById("ProductCount");
    // const containerDesktop = document.getElementById("ProductCountDesktop");
    // container.innerHTML = count;
    // container.classList.remove("loading");
    // if (containerDesktop) {
    //   containerDesktop.innerHTML = count;
    //   containerDesktop.classList.remove("loading");
    // }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter"
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const targetElement = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      if (targetElement) {
        targetElement.innerHTML = element.innerHTML;
      }
    });

    document.querySelectorAll(".facets__disclosure").forEach((item) => {
      let count = item.querySelectorAll(".facets__display input:checked").length;
      const resetBtn = item.querySelector(".facets__reset");
      if (resetBtn) {
        resetBtn.style.display = count === 0 ? "none" : "block";
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const targetFilter = event ? event.target.closest(".js-filter") : null;
      if (targetFilter) {
        FacetFiltersForm.renderCounts(countsToRender, targetFilter);
      }
    }

    updateSortBy();
    
    // Réinitialiser le bouton confirmer après le rendu
    FacetFiltersForm.reinitConfirmButtons();
  }

  static reinitConfirmButtons() {
    const confirmButton = document.getElementById('FacetsConfirmButton');
    if (confirmButton) {
      // Supprimer les anciens listeners en clonant l'élément
      const newConfirmButton = confirmButton.cloneNode(true);
      confirmButton.parentNode.replaceChild(newConfirmButton, confirmButton);
      
      newConfirmButton.addEventListener('click', () => {
        const form = document.getElementById('FacetFiltersForm');
        if (form) {
          const formData = new FormData(form);
          const searchParams = new URLSearchParams(formData).toString();
          FacetFiltersForm.renderPage(searchParams, null);
          document.querySelector("#main-collection-filters").classList.remove("filters-actif");
        }
      });
    }

    const mobileConfirmButton = document.getElementById('MobileFacetsConfirmButton');
    if (mobileConfirmButton) {
      const newMobileConfirmButton = mobileConfirmButton.cloneNode(true);
      mobileConfirmButton.parentNode.replaceChild(newMobileConfirmButton, mobileConfirmButton);
      
      newMobileConfirmButton.addEventListener('click', () => {
        const form = document.getElementById('FacetFiltersFormMobile');
        if (form) {
          const formData = new FormData(form);
          const searchParams = new URLSearchParams(formData).toString();
          FacetFiltersForm.renderPage(searchParams, null);
          const mobileWrapper = document.querySelector('.mobile-facets__wrapper');
          if (mobileWrapper) {
            const summary = mobileWrapper.querySelector('summary');
            if (summary) summary.click();
          }
        }
      });
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      const targetElement = document.querySelector(selector);
      if (targetElement) {
        targetElement.innerHTML = activeFacetsElement.innerHTML;
      }
    });
    
    document.querySelectorAll(".facets__disclosure").forEach((item) => {
      let count = item.querySelectorAll(".facets__display input:checked").length;
      const resetBtn = item.querySelector(".facets__reset");
      if (resetBtn) {
        resetBtn.style.display = count === 0 ? "none" : "block";
      }
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      const targetElement = document.querySelector(selector);
      if (targetElement) {
        targetElement.innerHTML = html.querySelector(selector).innerHTML;
      }
    });

    const mobileForm = document.getElementById("FacetFiltersFormMobile");
    if (mobileForm) {
      const menuDrawer = mobileForm.closest("menu-drawer");
      if (menuDrawer && menuDrawer.bindEvents) {
        menuDrawer.bindEvents();
      }
    }
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    if (sourceElement && targetElement) {
      targetElement.outerHTML = sourceElement.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    searchParams = searchParams.replaceAll("*", "");
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest("form"));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this))
    );

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector("a").addEventListener("click", (event) => {
      event.preventDefault();
      const form =
        this.closest("facet-filters-form") ||
        document.querySelector("facet-filters-form");
      form.onActiveFilterClick(event);
    });
    
    const openButton = document.querySelector(".facet-filters__open");
    if (openButton) {
      openButton.addEventListener("click", this.openFilters.bind(this));
    }
    
    const closeButton = document.querySelector(".facets-button-close");
    if (closeButton) {
      closeButton.addEventListener("click", this.closeFilters.bind(this));
    }
  }

  openFilters() {
    document.querySelector("#main-collection-filters").classList.add("filters-actif");
  }

  closeFilters() {
    document.querySelector("#main-collection-filters").classList.remove("filters-actif");
  }
}

customElements.define("facet-remove", FacetRemove);

function updateSortBy() {
  const sortSelect = document.querySelector("facet-filters-form .select.select__select");
  if (sortSelect) {
    sortSelect.addEventListener("click", () => {
      document.querySelector(".select-values").classList.add("open");
    });
  }
  
  document.querySelectorAll("[data-sort-by]").forEach((item) => {
    item.addEventListener("click", (e) => {
      let sort_by = e.currentTarget.dataset.sortBy;
      document.querySelector("#SortBy").value = sort_by;
      document
        .querySelector(".active-facets-desktop + facet-filters-form .facets__form")
        .dispatchEvent(new Event("input"));
      document.querySelector(".select-values").classList.remove("open");
      document.querySelector(".select.select__select").innerHTML = e.currentTarget.innerHTML;
    });
  });

  document.addEventListener("click", function (e) {
    const selectValues = document.querySelector(".select-values");
    if (selectValues && !e.target.closest(".select-values") && !e.target.closest(".select")) {
      selectValues.classList.remove("open");
    }
  });
}

function reloadPagination() {
  let page = 1;
  const url = new URL(window.location);
  const hasCurrentPage = url.searchParams.has("current-page");
  if (hasCurrentPage) {
    page = parseInt(url.searchParams.get('current-page'));
  }

  checkIfAllProductsAreShowed();
  updateCurrentPage();

  let button_load_more = document.querySelector(".collection-show-more");
  let button_load_all = document.querySelector(".collection-show-all");

  if (button_load_more) {
    button_load_more.addEventListener("click", function (e) {
      page++;
      let product_per_page = parseInt(e.currentTarget.dataset.loadMore);
      let products = document.querySelectorAll("#ProductGridContainer .grid__item");

      products.forEach((product, index) => {
        if (index < product_per_page * page) {
          product.classList.remove("hidden");
        }
      });

      updateProgressBar();
      updateUrlHistory(page);
    });
  }

  if (button_load_all) {
    button_load_all.addEventListener("click", function (e) {
      let products = document.querySelectorAll("#ProductGridContainer .grid__item");

      products.forEach((product, index) => {
        product.classList.remove("hidden");
      });

      updateProgressBar();
    });
  }

  updateProgressBar();
}

function updateProgressBar() {
  let progressbar_container = document.querySelector(".collection-progressbar");
  if (progressbar_container) {
    let product_showed = document.querySelectorAll("#ProductGridContainer .grid__item:not(.hidden)").length;
    let product_total = document.querySelectorAll("#ProductGridContainer .grid__item").length;

    let progress = (product_showed / product_total) * 100;
    document.documentElement.style.setProperty("--collection-progress-bar-width", `${progress}%`);
    updatePaginationCount();
  }
}

function updatePaginationCount() {
  let product_showed = document.querySelectorAll("#ProductGridContainer .grid__item:not(.hidden)").length;
  let pagination_count = document.querySelector("[data-current-count]");

  if (product_showed && pagination_count) {
    pagination_count.innerHTML = `${product_showed}`;
  }

  checkIfAllProductsAreShowed();
}

function checkIfAllProductsAreShowed() {
  let products = document.querySelectorAll("#ProductGridContainer .grid__item");
  let products_hidden = document.querySelectorAll("#ProductGridContainer .grid__item.hidden");

  if (products_hidden.length == 0) {
    document.querySelectorAll(".collection-show-more, .collection-show-all").forEach((button) => {
      button.classList.add("hidden");
    });
    updateUrlHistory("all");
  } else {
    return false;
  }
}

function updateUrlHistory(page) {
  let url = new URL(window.location.href);
  url.searchParams.set("current-page", page);
  window.history.pushState({ path: url.href }, "", url.href);
}

function updateCurrentPage() {
  let url = new URL(window.location.href);
  let page = url.searchParams.get("current-page");

  if (page) {
    const loadMoreBtn = document.querySelector(".collection-show-more");
    let product_per_page = loadMoreBtn ? parseInt(loadMoreBtn.dataset.loadMore) : 16;

    let products = document.querySelectorAll("#ProductGridContainer .grid__item");

    products.forEach((product, index) => {
      if (page == "all") {
        product.classList.remove("hidden");
      } else {
        let p = parseInt(page);
        if (index < product_per_page * p) {
          product.classList.remove("hidden");
        }
      }
    });

    updateProgressBar();
    page++;
  }
}

reloadPagination();

document.querySelectorAll(".product-card-v2 a").forEach((link) => {
  link.addEventListener("click", () => {
    sessionStorage.setItem("collectionScroll", window.scrollY);
    sessionStorage.setItem("collectionURL", window.location.href);
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const url = new URL(window.location);
  const hasCurrentPage = url.searchParams.has("current-page");
  const savedURL = sessionStorage.getItem("collectionURL");

  if (hasCurrentPage && savedURL === window.location.href) {
    const scroll = sessionStorage.getItem("collectionScroll");
    if (scroll !== null) {
      window.scrollTo(0, parseInt(scroll));
    }

    sessionStorage.removeItem("collectionScroll");
    sessionStorage.removeItem("collectionURL");
  }
});
